import {
  Table as BaseTable,
  TableBody,
  TableHeader,
  TableRow,
  cn,
} from "@rarible_int/anaconda_ui_components"

export { TableBody, TableHeader } from "@rarible_int/anaconda_ui_components"

export function Table(props: React.ComponentProps<typeof BaseTable>) {
  return <BaseTable {...props} className="w-full table-fixed" />
}

export function Row(props: React.ComponentProps<typeof TableRow>) {
  return <TableRow {...props} className="group border-none" />
}

export function HeaderRow({
  children,
  className,
}: { children: React.ReactNode; className?: string }) {
  return (
    <TableRow
      className={cn(
        "group z-10 bg-background text-foreground/60 uppercase transition-all duration-200 ease-in-out hover:bg-background",
        className,
      )}
    >
      {children}
    </TableRow>
  )
}

export function TableLayout({
  header,
  body,
}: {
  header: React.ReactNode
  body: React.ReactNode
}) {
  return (
    <Table>
      <TableHeader>{header}</TableHeader>
      <TableBody>{body}</TableBody>
    </Table>
  )
}
